import gql from 'graphql-tag'
import Constants from "../../Constants/Constants";

export const SUBSCRIBE_CUSTOMERS = gql`
subscription customers($offset: Int!, $limit: Int!, $filter: String!, $label: String_comparison_exp, $city: String_comparison_exp = {}, $customerTypeId:uuid_comparison_exp, $salesExecutiveId: uuid_comparison_exp = {}){
  Customers (where:{_and: [{label : $label}, {typeId : $customerTypeId}, {city: $city}, {salesExecutiveId: $salesExecutiveId}, {_or: [{name: {_ilike: $filter}}, {mobile: {_ilike: $filter}}, {email: {_ilike: $filter}} ]}]},
                    offset: $offset, limit: $limit, order_by: {created_at: desc}){
    id
    name
    type
    mobile
    email
    city
    profileImage
    CustomerType{id type colorCode}
    disableType
    askGst
    createdFrom
    SalesExecutive {id name profileImage}
    status
    label
    created_at
    updated_at
  }
}`

export const SUBSCRIBE_CUSTOMERS_COUNT = gql`
subscription customersCount($filter: String!, $label: String_comparison_exp, $city: String_comparison_exp = {}, $customerTypeId:uuid_comparison_exp, $salesExecutiveId: uuid_comparison_exp = {}){
  customersCount: Customers_aggregate (where:{_and: [{label :$label}, {typeId :$customerTypeId}, {city: $city}, {salesExecutiveId: $salesExecutiveId}, {_or: [{name: {_ilike: $filter}}, {mobile: {_ilike: $filter}},
                  {email: {_ilike: $filter}} ]}]}){
    aggregate{ count }
  }
}`

export const SUBSCRIBE_FILTERED_CUSTOMERS = gql`
subscription customers($createdAt:timestamptz!){
  filteredCustomers: Customers (where: {created_at: {_gte: $createdAt}}){
    id
    name
    type
    mobile
    email
    profileImage
    createdFrom
    status
    label
    city
    created_at
    updated_at
  }
}`

export const SUBSCRIBE_ALL_CUSTOMERS_COUNT = gql`
subscription allCustomersCount{
  allCustomersCount: Customers_aggregate{
     aggregate{  count}
  }
}`

export const SUBSCRIBE_CUSTOMER_BY_ID = gql`
  subscription customerById($id: uuid!){
    customer: Customers(where:{id: {_eq: $id}}){
     id
     name
     mobile
     email
     profileImage
     type
     warehouse{id name}
     CustomerType{id type colorCode}
     Session(limit: 1, order_by: {created_at: desc}){id deviceInfo}
     disableType
     askGst
     gstNumber
     isTransportFacilityActive
     status
     label
     created_at
     createdFrom
     companyName
     SalesExecutive {id name}
     CustomerAddress{id add1:address1 add2:address2 area city state country, pincode:pinCode}
     city
     CustomerCreditDetail {id creditLimit availableCredit dueDayLimit outstanding}
     Orders_aggregate {aggregate {sum {payableAmount}}}
     CreditDebit_aggregate(where: {type: {_eq: "CREDIT"}}) {aggregate {sum {amount}} }
     CreditDebit(where: {note: {_eq: "opening_balance_added_by_admin"}}) {id amount type}
     Orders (order_by: {created_at: desc}){
      id 
      payableAmount
      orderType
      orderNumber
      OrderItems_aggregate{ aggregate {count}}
      created_at 
      Status{id status}
      CreditDebit_aggregate(where: {type: {_eq: "CREDIT"}}) { aggregate {sum {amount}}}
     }
   }
  }
`
export const SUBSCRIBE_TODAYS_CUSTOMERS = gql`
subscription todaysCustomersCount($createdAt:timestamptz!){
  todaysCustomersCount: Customers_aggregate(where: {created_at: {_gte: $createdAt}}){
    aggregate{ count }
  }
}`
export const SUBSCRIBE_TOP_10_CUSTOMERS_BY_AMOUNT = gql`
subscription top10CustomersByAmount($startDate:timestamptz!, $endDate:timestamptz!, $warehouseStr:String!, $warehouseArr:uuid_comparison_exp){
   top10CustomersByAmount: top_customers_by_amount(args: {startdate: $startDate, enddate: $endDate, warehouse: $warehouseStr}, limit:10) {
    id
    name
    city
    profileImage
    Orders_aggregate (where: {_and: [{delivered_at: {_gte: $startDate}}, {delivered_at: {_lte: $endDate}}, {fromWarehouseId: $warehouseArr},
                                     {statusId: {_eq: "${Constants.OrderStatuses.Delivered}"}}]}){
      aggregate {sum {payableAmount }}
    }
  }   
}`
